import factory from './icon';
import Svg24x2 from './glyphs/Line_24x2.svg';

export const Line24x2 = factory(Svg24x2, 24, 2);